import styled from 'styled-components'
import {
  COLOR,
  Z_INDEXS,
} from '../../themes'
const widthLoad = 50
export const StyleLoader = styled.div`
  .block{
    display: block;
    position: fixed;
    width: 100%;
    background: ${COLOR.LOADING};
    height: 100%;
    top: 0;
    left:0;
    border: 1px solid ${COLOR.GRAY_3};
    z-index: ${Z_INDEXS.LV_11};
  }

  .box-loader {
    position: fixed;
    border-radius: 50%;
    width: ${widthLoad + 24}px;
    height: ${widthLoad + 24}px;
    left: calc(50% - ${(widthLoad + 24) / 2}px);
    top: calc(50% - ${(widthLoad + 24) / 2}px);
    z-index: ${Z_INDEXS.LV_MAX};
  }
  .loader{
    border: 6px solid ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    border-radius: 50%;
    border-top: 6px solid ${COLOR.WHITE};
    width: ${widthLoad}px;
    height: ${widthLoad}px;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 1s linear infinite;
    margin-left: 6px;
    margin-top: 6px;
   }

  /* Safari */
  @-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`
